import { Link } from "react-router-dom";
import Logo from "./Logo";
import { ADDRESS, NAV } from "../data/site";

const COMPANY_LINKS = [
    { label: "Our Story", path: "/company/story" },
    { label: "What Makes AddiGen Different", path: "/company/difference" },
    { label: "Our Mission", path: "/company/mission" },
    { label: "Our Values", path: "/company/values" },
    { label: "Senior Leadership Team", path: "/company/leadership" },
    { label: "Partners & Stakeholders", path: "/company/partners" },
    { label: "FAQ", path: "/company/faq" },
];

const LEGAL_LINKS = [
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Cookie Policy", path: "/cookies" },
    { label: "Terms of Use", path: "/terms" },
    { label: "Sitemap", path: "/sitemap" },
];

export default function Footer() {
    return (
        <footer className="bg-navy text-footer-text" data-testid="site-footer">
            <div className="container-x grid gap-14 py-16 sm:py-20 lg:grid-cols-12 lg:gap-8">
                <div className="lg:col-span-4">
                    <Logo light />
                    <p className="body-sm mt-6 max-w-xs text-white/60">
                        Europe's long-duration energy storage developer.
                    </p>
                    <address className="mt-8 not-italic font-mono text-[12px] leading-[1.9] uppercase tracking-[0.14em] text-white/45">
                        {ADDRESS.lines.map((l) => (
                            <span key={l} className="block">{l}</span>
                        ))}
                    </address>
                </div>
                <nav aria-label="Footer navigation" className="lg:col-span-2">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/40">Navigation</p>
                    <ul className="mt-6 space-y-3">
                        {NAV.map((n) => (
                            <li key={n.label}>
                                <Link to={n.path} className="text-sm text-white/75 transition-colors hover:text-blue-bright">
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
                <nav aria-label="Company pages" className="lg:col-span-3">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/40">Company</p>
                    <ul className="mt-6 space-y-3">
                        {COMPANY_LINKS.map((c) => (
                            <li key={c.path}>
                                <Link to={c.path} className="text-sm text-white/75 transition-colors hover:text-blue-bright">
                                    {c.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
                <nav aria-label="Legal" className="lg:col-span-3">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/40">Legal & Social</p>
                    <ul className="mt-6 space-y-3">
                        {LEGAL_LINKS.map((l) => (
                            <li key={l.path}>
                                <Link to={l.path} className="text-sm text-white/75 transition-colors hover:text-blue-bright" data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm text-white/75 transition-colors hover:text-blue-bright" data-testid="footer-linkedin">
                                LinkedIn
                                <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" aria-hidden="true"><path d="M1 11 11 1M4 1h7v7" fill="none" stroke="currentColor" strokeWidth="1.4" /></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div className="border-t border-line-navy">
                <div className="container-x flex flex-col items-start justify-between gap-3 py-6 sm:flex-row sm:items-center">
                    <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/40">
                        © 2026 AddiGen Holdings Limited. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        <Link to="/sitemap" className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/40 transition-colors hover:text-blue-bright">Sitemap</Link>
                        <Link to="/careers" className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/40 transition-colors hover:text-blue-bright">Careers</Link>
                        <Link to="/contact" className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/40 transition-colors hover:text-blue-bright">Contact</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
